export const formatFileTypes = (mimeTypes: string[]): string => {
  return mimeTypes
    .map((type) => {
      const format = type.split("/")[1]?.toUpperCase() ?? "UNKNOWN";
      return format;
    })
    .join(", ");
};
